<template>
    <section class="plugin-home-faq">
        <div class="plugin-home-faq__container">
            <div class="plugin-home-faq__link">
                <plugin-home-common-arrow-link
                    v-bind:text="buttonText"
                    v-bind:url="buttonUrl"
                />
            </div>

            <plugin-home-common-title v-bind:text="title" />

            <div class="plugin-home-faq__content">
                <div class="plugin-home-faq__content-media">
                    <plugin-home-image
                        v-bind:image="image"
                        v-bind:title="imageText"
                        position="bottom"
                        style="border-radius: 0"
                    />
                </div>
                <div class="plugin-home-faq__content-text">
                    <common-accordion :items="items" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
// import utils from '~/utils';

export default {
    name: 'plugin-home-faq',
    props: {
        title: {
            type: String,
            default: '',
        },
        image: {
            type: String,
            default: '',
        },
        imageText: {
            type: String,
            default: '',
        },
        buttonText: {
            type: String,
            default: '',
        },
        buttonUrl: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({

    }),
    computed: {
        isMobile() {
            return window.innerWidth < 768;
        },
    },
    methods: {

    },
    mounted() {

    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-faq {
    .container-landing();

    &__container {
        position: relative;
        width: 100%;
        max-width: @landing-max-width;
        min-height: 460px;
    }
    &__link {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
    }
    &__content {
        display: grid;
        grid-template-columns: 46% 1fr;
        width: 100%;
        max-height: 760px;
        background-color: white;
        border-radius: 54px;
        overflow: hidden;

        &-media {
            display: flex;
            align-items: center;
            justify-content: center;
            max-height: 760px;
            overflow: hidden;
        }
        &-text {
            padding: 48px;
            max-height: 760px;
            overflow-y: auto;
        }
    }
    @media @media-md-down {
        &__link {
            justify-content: flex-start;
        }
        &__content {
            grid-template-columns: 1fr;
            height: auto;
            max-height: none;
            border-radius: @border-radius-xxl;
            &-media {
                height: 240px;
            }
            &-text {
                padding: 24px 20px;
                max-height: none;
            }
        }
    }
}
</style>
